module.exports = __webpack_public_path__ + "04a9b1c219dbe8eb3a3e59fd398eb4d7.png";